<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body" v-show="currentModal==='select'">
          <div class="row my-4">
            <div class="col-12">
              <form class="form">
                <div class="input-group input-lg">
                  <div class="input">
                    <input
                      type="text"
                      name="keyword"
                      id="keyword"
                      class="form-control"
                      v-model="keyword"
                      placeholder="輸入姓名、身分證進行搜尋..."
                    />
                  </div>
                  <button
                    class="btn btn-primary btn-icon"
                    type="submit"
                    @click.prevent="doSearch()"
                  >
                    <i class="icon-search i-24"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div class="row row newTable select">
            <div class="col-12">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th :width="Math.floor(718 * 0.15) + 'px'" class="text-center">#</th>
                    <th :width="Math.floor(718 * 0.20) + 'px'">戶長姓名</th>
                    <th :width="Math.floor(718 * 0.26) + 'px'">身分證</th>
                    <th :width="Math.floor(718 * 0.20) + 'px'">生日</th>
                    <th>歲數</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in familiesAry" :key="`familiy-item-${i}`">
                    <!-- <td :width="Math.floor(718 * 0.13) + 'px'" class="d-flex justify-content-between align-items-center px-3"> -->
                    <td :width="Math.floor(718 * 0.15) + 'px'">
                      <div class="d-flex align-items-center">
                        <div class="radio radio-inline">
                          <input
                            type="radio"
                            v-model="selectedHolder"
                            :id="`family-${i+1}`"
                            :value="item.holderid"
                            @change="handleChange(item.holderid)"
                          />
                          <label :for="`family-${i+1}`">{{i + 1}}</label>
                        </div>
                        <img
                          :src="item.gender === 0 ?
                      `${BaseUrl}assets/common/gender_woman_s.png` :
                      (item.gender === 1 ?
                      `${BaseUrl}assets/common/gender_man_s.png` :
                      `${BaseUrl}assets/common/gender_unknow_s.png`)"
                          :srcset="item.gender === 0 ?
                      `${BaseUrl}assets/common/gender_woman_s@2x.png` :
                      (item.gender === 1 ?
                      `${BaseUrl}assets/common/gender_man_s@2x.png` :
                      `${BaseUrl}assets/common/gender_unknow_s@2x.png`)"
                          width="20"
                          height="20"
                          class="avatar"
                        />
                      </div>
                    </td>
                    <td :width="Math.floor(718 * 0.20) + 'px'">
                      <a
                        class="link text-underline"
                        style="word-break: break-all;"
                      >{{item.holdername}}</a>
                    </td>
                    <td :width="Math.floor(718 * 0.26) + 'px'">
                      <div
                        v-if="item.holderid && (item.holderid.includes('~') || item.holderid.includes('#'))"
                      ></div>
                      <div v-else>{{item.holderid}}</div>
                    </td>
                    <td :width="Math.floor(718 * 0.20) + 'px'" v-if="item.birthday!='8088/12/31' && item.birthday">{{item.birthday}}</td>
                    <td :width="Math.floor(718 * 0.20) + 'px'" v-else>— —</td>
                    <td>{{item.age}} 歲</td>
                    <!-- <td>{{item.birthday | dateFormat}}</td>
                    <td>{{item.birthday | ageCounter}}</td>-->
                  </tr>
                </tbody>
              </table>
              <div class="actions text-right mt-4">
                <a @click="$emit('close')" class="btn btn-default">取消加入</a>
                <a
                  :disabled="selectedHolder===''"
                  @click="goToPage('comfirm')"
                  class="btn btn-primary"
                >加入此家戶</a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body" v-show="currentModal==='comfirm'">
          <div class="row newTable comfirm">
            <div class="col-md-12">
              <h5>本次加入的成員：</h5>
              <table id="customer-list" class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th>姓名</th>
                    <th>身分</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{this.selectedFamily.name}}</td>
                    <td class="action-button">
                      <span class="text">
                        <select
                          v-model="selectedFamily.relation"
                          class="form-control form-control-inline form-short"
                          @change="checkrelation()"
                        >
                          <option value="">請選擇</option>
                          <option
                            v-for="(role, j) in roleOpt"
                            :value="(j+1).toString()"
                            :key="`role-select-${j}`"
                          >{{role}}</option>
                        </select>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row newTable comfirm">
            <div class="col-md-12">
              <h5>家戶成員列表:</h5>
              <table id="new-group-list" class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th>姓名</th>
                    <th>身分</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in familiesSelect" :key="`familiy-item-${i}`">
                    <td>{{item.name}}</td>
                    <td>
                      <div v-if="item.relation=='0'">戶長</div>
                      <div v-else-if="item.relation=='1'">配偶</div>
                      <div v-else-if="item.relation=='2'">子女</div>
                      <div v-else-if="item.relation=='3'">父母</div>
                      <div v-else-if="item.relation=='5'">孫子女</div>
                      <div v-else>其他</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="actions text-right mt-4">
                <button @click="goToPage('select')" class="btn btn-default">上一步</button>
                <button
                  @click="submit"
                  :disabled="!isRelationSelected"
                  class="btn btn-primary"
                >確認</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getFamilyMembers } from "../../service/index";

export default {
  name: "FamilyModal",
  props: {
    families: {
      type: Array,
      default: () => {
        return [];
      }
    },
    open: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      default: {
        age: "",
        birthday: "",
        guid: "",
        householderid: "",
        link: "",
        name: "",
        personalid: "",
        relation: "",
        sex: ""
      }
    }
  },
  computed: {
    ...mapGetters(["BaseUrl","CustInfo"])
  },
  watch: {
    open: "modalChange"
  },
  data() {
    return {
      isRelationSelected: false,
      keyword: "",
      currentModal: "select",
      //selectedFamily: [],
      selectedFamily: {
        name:"",
        relation:""
      },
      familiesSelect: [],
      selectedHolder: "",
      roleOpt: ["配偶", "子女", "父母", "其他", "孫子女"],
      familiesAry: []
    };
  },
  methods: {
    goToPage(pageName) {
      console.log(pageName);
      this.currentModal = pageName;
    },
    handleChange(holderid) {
      this.selectedHolder = holderid;
      //this.selectedFamily = [this.CustInfo];
      getFamilyMembers(this.$store.state.userInfo.id, this.selectedHolder).then(
        result => {
          if (result.header && result.header.status === "200") {
            this.familiesSelect = result.body.familymembers;
          } else {
            console.log("回傳失敗");
          }
        }       
      );
    },
    doSearch() {
      this.familiesAry = [];
      setTimeout(() => {
        this.familiesAry = this.families.filter(member => {
          return (
            member.holdername.includes(this.keyword) ||
            member.holderid.includes(this.keyword)
          ) && member.holderid != this.customer.householderid;
        });
        this.registerHanlink();
      }, 200);
    },
    modalChange(value) {
      this.keyword = "";
      if(value) {
        this.currentModal = "select";
        this.selectedHolder = "";
        if(this.customer.personalid) {
          this.selectedFamily.name = this.customer.name;
          this.selectedFamily.relation = "";
        }
        else {
          this.selectedFamily.name = this.CustInfo.name;
          this.selectedFamily.relation = "";    
        }

        this.familiesAry = [...this.families];
      } 

      setTimeout(() => {
        this.registerHanlink();
      }, 200);
    },
    checkrelation(){
      if(this.selectedFamily.relation){
        this.isRelationSelected = true;      
      }else{
        this.isRelationSelected = false; 
      }
    },
    submit() {
      if (this.familiesSelect && this.familiesSelect.length > 0) {
        if (this.selectedFamily.relation === "1" && this.familiesSelect.some(f=> f.relation === "1")) {
           this.$toast.info({ title: "新增家庭成員失敗:保校家庭中不可同時擁有兩位配偶" });
           return;
        }
      }

      this.$emit('submit', this.selectedHolder, this.selectedFamily);
    }
  }, 
};
</script>


<style lang="scss" scoped>
h5 {
  margin-top: 0;
}

.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.actions {
  .btn {
    margin: 0;
    width: 120px;
  }
  .btn:not(:last-of-type) {
    margin-right: 20px;
  }
}

.close {
  position: absolute;
  right: -12px;
  top: -12px;
  display: block;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 22px;
  color: white;
  background: #5b616a;
  border: 2px solid #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
  -ms-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
  -o-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
}

table.table.insurance-green > thead > tr {
  border-top-width: 0px !important;
  border-left-width: 0px !important;
  border-right-width: 0px !important;
  border-bottom-width: 0px !important;
  & > th {
    text-align: left;
    padding: 9px 6px !important;
    border-right: 1px dotted #c2c4c7 !important;
    border-left-width: 0px !important;
    border-bottom-width: 0px !important;
    font-size: 15px;
    z-index: 9;

    &:last-of-type {
      border-right-width: 0px !important;
    }
  }
}

.newTable {
  tr:first-of-type {
    td {
      border-top-width: 0;
    }
  }

  tr {
    td:first-of-type {
      border-left-width: 0;
    }

    td:last-of-type {
      border-right-width: 0;
    }
  }

  &.select {
    tbody {
      height: 400px;
    }
  }

  thead {
    border: 1px solid #53c480;
    background: #e5f6ec;
  }

  tbody {
    tr {
      td {
        border-bottom-width: 0;
        border-top-width: 0;
      }

      td:first-of-type {
        border-right: 1px dotted #c2c4c7 !important;
      }

      td:last-of-type {
        border-left: 1px dotted #c2c4c7 !important;
      }
    }
  }

  &.comfirm {
    th,
    td {
      max-width: 350px;
    }
    tbody {
      min-height: 115px;
      max-height: 200px;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 16px;
        border: 0;
        box-shadow: none;
      }

      &::-webkit-scrollbar-track {
        box-shadow: none;
        border-radius: 0px;
        border: 0;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-thumb {
        width: 10px;
        border-radius: 20px;
        background-color: #555;
      }
    }

    &:first-of-type {
      margin-bottom: 20px;
    }

    thead {
      border: 1px solid #53c480;
      background: #e5f6ec;
      tr {
        padding-right: 16px;
        display: table;
        width: calc(100% - 16px);
        table-layout: fixed;
      }

      th:last-of-type {
        border-width: 0;
      }
    }
  }

  th {
    position: relative;
    &.sort::after {
      position: absolute;
      content: "";
      top: 15px;
      right: 9px;
      border-top: 6px solid rgba(2, 122, 57, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }
  }

  tbody {
    display: block;
    overflow-y: scroll;
    scrollbar-width: none;
    border: 0 !important;
    -webkit-overflow-scrolling: touch;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
  .newTable.comfirm thead {
    tr {
      width: calc(100%);
    }
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
  .newTable.comfirm thead {
    tr {
      width: calc(100%);
    }
  }
}

@media only screen and (-webkit-min-device-pixel-ratio: 1) and (max-device-width: 1024px) and (min-device-width: 768px) and (orientation: landscape) {
  .newTable.comfirm thead {
    tr {
      width: calc(100%);
    }
  }
}
</style>